import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const MUTATION = gql`
  mutation performanceCenterCreateCustomModel(
    $customerId: ID!
    $assetType: PerformanceCenterAssetType!
    $modelName: String!
    $campaignIds: [String!]!
    $metricToPredict: PerformanceCenterMetricToPredict!
  ) {
    performanceCenterCreateCustomModel(
      customerId: $customerId
      assetType: $assetType
      modelName: $modelName
      campaignIds: $campaignIds
      metricToPredict: $metricToPredict
    ) {
      id
      title
      status
    }
  }
`;

export const createCustomScoringModel = ({
  customerId,
  assetType,
  modelName,
  campaignIds,
  metricToPredict,
}) => {
  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables: { customerId, assetType, modelName, campaignIds, metricToPredict },
    })
    .then(({ data }) => getSingleProp(data));
};
